import { TodoDescriptor } from '../../schema/TodoDescriptor';
import { OrderByValue } from 'owa-todo-service';

export function getOrderByValueForDescriptor(descriptor: TodoDescriptor): OrderByValue {
    const { orderBy } = descriptor;
    if (orderBy !== undefined) {
        return orderBy;
    }
    return OrderByValue.OrderDateTime;
}
